
import React from 'react';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CreateOutputApp from '../Functionality/CreateOutputApp';
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {MenuItem} from "@mui/material";
import {MIN_MAX_OUTPUT, OUTPUT_NUMBER_DATA} from "../Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateOutputModal = (props) => {
    const { onHide, controllerId, setModified } = props;
    const {
        t,
        output,
        handleChange,
        emptyFields,
        isValidDefaultPulse,
        controllers,
        sioIds,
        handleSubmit,
        resetValues
    } = CreateOutputApp({ onHide, controllerId, setModified });

    return (
        <CustomModal
            title='create_output'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                resetValues();
            }}
            onConfirm={() => {
                handleSubmit();
            }}
        >
            <div className='row'>
                <div className='col-12'>
                    <CustomTextField id={"txt_com_name"}
                        trans={"name"}
                        name={"name"}
                        type={"text"}
                        value={output.name}
                        onChange={handleChange}
                        required={true}
                        emptyFields={emptyFields}
                        length={128}
                    />
                </div>

                {controllerId == null &&
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_com_controller"}
                                             name={"controllerId"}
                                             trans={"controller"}
                                             value={output.controllerId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                    >
                        {Array.isArray(controllers) &&
                        controllers.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
                }
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_com_sio"}
                                             name={"hidSioId"}
                                             trans={"SIO"}
                                             value={output.hidSioId}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                                             disabled={!output.controllerId}
                    >
                        {Array.isArray(sioIds) &&
                            sioIds.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))
                        }
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelectAndChildren id={"slt_com_number"}
                                             name={"number"}
                                             trans={"output_number"}
                                             value={output.number}
                                             onChange={handleChange}
                                             required={true}
                                             emptyFields={emptyFields}
                                             showNoSelectionOption={false}
                    >
                        {Object.values(OUTPUT_NUMBER_DATA).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomTextField id={"txt_com_default_pulse"}
                                     trans={"default_pulse"}
                                     name={"defaultPulse"}
                                     type={"number"}
                                     value={output.defaultPulse}
                                     onChange={handleChange}
                                     required={true}
                                     emptyFields={emptyFields}
                                     length={3}
                                     isValid={isValidDefaultPulse}
                                     isValidText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_OUTPUT.DEFAULT_PULSE.start, max:MIN_MAX_OUTPUT.DEFAULT_PULSE.end})}
                                     helperText={t("it_must_be_greater_than_x_or_equal_to", {min:MIN_MAX_OUTPUT.DEFAULT_PULSE.start, max:MIN_MAX_OUTPUT.DEFAULT_PULSE.end})}

                    />
                </div>
            </div>
        </CustomModal>

    );
};

export default CreateOutputModal;
